import { useEffect } from 'react';
import { useMeetingContext } from 'Context/MeetingContext';

// Deprecated
export default function useMissionControlMeetingEffect(onChange) {
  const { meetingResource } = useMeetingContext();

  useEffect(() => {
    if (meetingResource) {
      onChange(meetingResource);
    }
  }, [meetingResource?.id()]);
}
